<template>
    <div class="study-more">
        <studySearch ref="studySearch"  
        :hotwordList="hotwordList" 
        :sourceType="'studyMore'"
        @searchClick="searchClick"></studySearch>

        <div class="study-more-cont">
            <div class="more-tab" v-if="titList">
                <el-tabs v-model="subType" type="card" @tab-click="tabClick">
                    <el-tab-pane
                        v-for="(item, index) in titList"
                        :key="index"
                        :label="item.val"
                        :name="item.type"
                        />
                </el-tabs>
            </div>
            <ul class="clinic-list" v-loading="listLoad">
                <li class="list-info" v-for="(item, index) in clinicList" :key="index">
                    <div class="info-label">{{ item.firstClassification }}</div>
                    <div class="info-val">
                        <p v-for="(list, num) in item.secondClassificationMapList" :key="num" @click="toPage(item, list)">
                            <el-tooltip
                                v-if="(list || '').length > 12"
                                :content="list"
                                placement="top"
                            >
                                <span>{{ list.label }}</span>
                            </el-tooltip>
                            <span v-else>{{ list.label }}</span>
                        </p>
                    </div>
                </li>
            </ul>
            <el-pagination
                v-if="pageInfo.total != 0"
                @current-change="changePage"
                :current-page="pageInfo.pageNum"
                :page-count="pageInfo.pageTotal"
                :page-size="pageInfo.pageSize"
                :total="pageInfo.total"
                background
                layout="total, prev, pager, next"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script> 
import studySearch from './comps/study_search.vue'
import { clinicList,topicList } from '../../io/api'

// 临床：subType 1 临床指南 2 名医经验
const CLINIC_TIT_LIST = [
    { val: '临床指南', type: '1' },
    { val: '名医经验', type: '2' },
]
// 中医：subType 3 方剂医案 4 中药课堂 5 常用中成药
const TCM_TIT_LIST = [
    { val: '方剂医案', type: '3' },
    { val: '中药课堂', type: '4' },
    { val: '常用中成药', type: '5' },
]

export default {
    components: {
        studySearch,
    },
    data() {
        return {
            searchVal: '',
            listLoad: false,
            subType: this.$route.query.subType || '',
            clinicList: [], 
            hotwordList: [
                { val: '2型糖尿病' },
                { val: '失眠' },
                { val: '李佃贵' },
                { val: '百合固金汤' },
                { val: '大定风珠' },
            ],
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },
        }
    },
    computed: {
        // 根据 subType 取对应的 tab 列表：1、2 用临床，3、4、5 用中医
        titList() {
            const t = String(this.subType)
            // if(t!='topic'){
            //     if (t === '1' || t === '2') return CLINIC_TIT_LIST
            //     return TCM_TIT_LIST
            // }
            if (t === '1' || t === '2') return CLINIC_TIT_LIST
            if (t === '3' || t === '4'|| t === '5') return  TCM_TIT_LIST
            
        },
        // 请求的 type：临床为 1，中医为 2
        apiType() {
            const t = String(this.subType)  
            return (t === '1' || t === '2') ? 1 : 2
        },
        // 是否传 keyWord（仅临床传）
        needKeyWord() {
            const t = String(this.subType)
            return t === '1' || t === '2'
        }, 
    },
    mounted() {
        if(this.subType=='topic'){
            this.hotwordList=[{ val: '孙思邈' },
                { val: '金匮要略' },
                { val: '伤寒论' },
                { val: '钱乙' }, ]
            this.getTopic(1)
        }else{
            this.getList(1); 
        }
       
    },
    methods: {  
        tabClick(tab) {
            const type = tab.name;
            this.subType = type;
            this.getList(1);
        },
        getList(num) {
            this.listLoad = true
            const params = {
                page: num || this.pageInfo.pageNum,
                limit: this.pageInfo.pageSize,
                type: this.apiType,
                subType: this.subType,
            }
            if (this.needKeyWord) {
                params.keyWord = this.searchVal
            }
            clinicList(params).then(res => {
                const { code, data, msg } = res.data
                if (code === 0) {
                    this.clinicList = data.list || []; 
                    this.pageInfo.total = data.total != null ? data.total : 0
                } else {
                    this.$message.error(msg || '请求失败～')
                }
                this.listLoad = false
            })
        },
        //题库
        getTopic(num){
            this.listLoad = true
            const params = {
                page: num || this.pageInfo.pageNum,
                limit: this.pageInfo.pageSize, 
            } 
            topicList(params).then(res => {
                const { code, data, msg } = res.data
                if (code === 0) {
                    this.clinicList = data.list || []; 
                    this.pageInfo.total = data.total != null ? data.total : 0
                } else {
                    this.$message.error(msg || '请求失败～')
                }
                this.listLoad = false
            })
        },  
        // 搜索点击事件
        searchClick() { 
            this.toPage()
        },
        toPage(item, list) {  
            // 获取 studySearch 的搜索值
            this.searchVal = this.$store.state.study.searchVal;  
            const query = {
                subType: this.subType, 

            }
            if(item){
                query.firstClassification = item.firstClassification ||''
            }
            if(list){
                query.secondClassification = list.label||''
            }
            // searchVal 有值：直接跳转 studyDetails
            if (this.searchVal) {
                query.searchWord = this.searchVal
                let url = this.$router.resolve({ path: '/studyDetails', query })
                if(this.subType=='topic'){
                    url = this.$router.resolve({ path: '/studyTopicDetails', query })
                } 
                this.$windowOpen({ url: url.href, isLogin: true })
                return
            }
            // searchVal 为空：再判断 list.type
            if (list && list.type === 'link') {
                window.open(list.url, '_blank')
                return
            }
            let url = this.$router.resolve({ path: '/studyDetails', query })
            if(this.subType=='topic'){
                url = this.$router.resolve({ path: '/detailsTopic', query })
            } 
            this.$windowOpen({ url: url.href, isLogin: true })
        },
        changePage(num) {
            this.pageInfo.pageNum = num
            if(this.subType=='topic'){
                this.getTopic(num)
            }else{

                this.getList(num)
            }
        },
    },
}
</script>

<style lang="less" scoped>
.study-more {
    .study-more-cont {
        width: 1200px;
        margin: 40px auto;
        .more-tab{
            ::v-deep .el-tabs__item{
                font-size: 16px;
                padding:0 40px
                 
            }
            ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active{
                font-weight: bold;
                background: #F1F5FE;
                // background: #386DE8;
                color: #386DE8;
            } 
        }
    }
    .clinic-list {

        min-height: 500px;
        margin-bottom: 10px;
        .list-info {
            margin-bottom: 20px;
            width: 100%;
            background: #FCFCFC;
            border: 1px solid #E9ECEF;
            padding: 14px;
            &:hover {
                background: #EAF1FF;
                box-shadow: 0px 2px 4px 0px rgba(22, 93, 255, 0.04);
                border: 1px solid #A0BDFF;
                .info-txt, .txt, .sublevel-txt {
                    color: #386DE8;
                }
            }
            .info-label {
                font-size: 18px;
                line-height: 20px;
                margin-bottom: 10px;
                font-weight: bold;
                color: #386DE8;
            }
            .info-val {
                display: flex;
                flex-wrap: wrap;
                p {
                    width: 210px;
                    line-height: 24px;
                    margin: 0 12px;
                    span {
                        margin: 4px 0;
                        display: inline-block;
                        cursor: pointer;
                        font-size: 14px;
                        &:hover{
                            color: #386DE8;
                        }
                    }
                }
            }
        }
    }
}
</style>
